import React from "react";
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_inventory-manager-30/artifacts/sis1j2zy_logo.png" 
                alt="RESET Logo" 
                className="h-12 w-auto"
              />
              <div>
                <div className="text-2xl font-bold">RESET</div>
                <div className="text-gray-400 text-sm">Soluciones Empresariales</div>
              </div>
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              Desarrollamos SAIP, el sistema de control de inventarios más avanzado del mercado. 
              Transformando empresas desde 2020.
            </p>
            
            <div className="flex space-x-4">
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-xl font-bold mb-6">Productos</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">SAIP Professional</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">SAIP Enterprise</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">App Móvil</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">API Integración</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">Módulos Personalizados</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-xl font-bold mb-6">Soporte</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">Centro de Ayuda</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">Documentación</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">Tutoriales</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">API Docs</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">Estado del Sistema</a></li>
              <li><a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">Contactar Soporte</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contacto</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Phone className="text-blue-400 flex-shrink-0" size={18} />
                <div>
                  <div className="font-semibold">Ventas</div>
                  <a href="tel:+1234567890" className="text-gray-300 hover:text-blue-400 transition-colors">
                    +1 (234) 567-890
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Mail className="text-blue-400 flex-shrink-0" size={18} />
                <div>
                  <div className="font-semibold">Email</div>
                  <a href="mailto:ventas@reset.com" className="text-gray-300 hover:text-blue-400 transition-colors">
                    ventas@reset.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <MapPin className="text-blue-400 flex-shrink-0" size={18} />
                <div>
                  <div className="font-semibold">Oficina</div>
                  <div className="text-gray-300">
                    123 Tech Avenue<br />
                    Ciudad Empresarial, CP 12345
                  </div>
                </div>
              </div>
            </div>

            {/* Newsletter */}
            <div className="mt-8 p-4 bg-gray-800 rounded-lg">
              <h4 className="font-semibold mb-3">Newsletter</h4>
              <p className="text-gray-300 text-sm mb-4">
                Recibe las últimas novedades de SAIP
              </p>
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="tu@email.com"
                  className="flex-1 px-3 py-2 bg-gray-700 text-white rounded-l-lg border-none outline-none"
                />
                <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-r-lg transition-colors">
                  <Mail size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-16 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} RESET. Todos los derechos reservados. SAIP es una marca registrada de RESET.
            </div>
            
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                Términos de Servicio
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                Cookies
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                Legal
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-2xl transition-all transform hover:scale-110 z-50"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="m18 15-6-6-6 6"/>
        </svg>
      </button>
    </footer>
  );
};

export default Footer;